module.exports = __webpack_public_path__ + "img/moment-of-bloom.9c3b66a8.webp";